import React from "react";
import IconHome from "@mui/icons-material/Home";
import IconChevron from "@mui/icons-material/ChevronRight";
import "./AppBanner.css";

const AppBanner = ({ banner }) => {
  return (
    <div className="app-banner">
      <h1>{banner?.title}</h1>
      <div className="bread-crumbs">
        <div className="icon-home">
          <IconHome />
        </div>
        {banner?.breadCrumbs?.map((item) => (
          <>
            <IconChevron />
            <a href={item?.link}>
              <div className="link">{item?.title}</div>
            </a>
          </>
        ))}
        <IconChevron />
        <div className="link">{banner?.title}</div>
      </div>
    </div>
  );
};

export default AppBanner;
